import * as svg from "../../../assets/houfy-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const HoufyIcon = iconBuilder(svg, "HoufyIcon", "0 0 80.6 74.4");
